import axios from 'axios'

import { loginRequest } from '@/authConfig'
import { msalInstance } from '@/main'

export const getUser = async () => {
  const account = msalInstance.getActiveAccount()
  if (!account) return null

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    })

    if (response && response.accessToken) {
      const userRes = await axios.get('https://graph.microsoft.com/v1.0/me', {
        headers: {
          Authorization: `Bearer ${response.accessToken}`,
        },
      })
      return userRes.data
    }
  } catch (error) {
    console.error('Error fetching user:', error)
  }
  return null
}

export const getAvatar = async (id: string) => {
  const account = msalInstance.getActiveAccount()
  if (!account) throw new Error('No active account!')

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    })

    if (response && response.accessToken) {
      const avatarRes = await axios.get(
        `https://graph.microsoft.com/v1.0/users/${id}/photo/$value`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        },
      )
      return avatarRes.data // This is a Blob
    }
  } catch (error) {
    console.error('Error fetching avatar:', error)
  }
  return null
}
